import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { TipoDocumento } from 'src/app/models/TipoDocumento';
import { Validators, FormGroup, FormControl } from '@angular/forms';
import { TipoDocumentoService } from 'src/app/services/tipo-documento.service';
import { PersonaReniecService } from 'src/app/services/persona-reniec.service';
import { PersonaService } from 'src/app/services/persona.service';
import { PersonaReniec } from 'src/app/models/PersonaReniec';
import { Persona } from 'src/app/models/Persona';
import { MatDialog } from '@angular/material/dialog';
import { openModalMensaje, ConvertStringDateStr, ConvertStrDateToFormatBD, stringFechaMaxima, anioActualGlobal, ConvertDateTimeToStr3, ageFromDateOfBirth, constobraPublica, isEmpty, ConvertDateTimeToStr, ConvertDateTimeToStrForBD, ConvertDateTimeToStr4, NumIdTipoDocDNI, DscMensajeSpinner, openModalMensajePrg } from 'src/app/general/variables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Denunciante } from 'src/app/models/Denunciante';
import { ValidarFechaLength } from 'src/app/general/Funciones';


@Component({
  selector: 'app-persona-natural',
  templateUrl: './persona-natural.component.html',
  styleUrls: ['./persona-natural.component.css']
})
export class PersonaNaturalComponent implements OnInit {

  listTipoDocumento: TipoDocumento[] = [];
  personaReniec: PersonaReniec = new PersonaReniec();
  persona: Persona = null; // new Persona();
  personaOut: Persona = new Persona(); // new Persona();
  dscMask: string;
  flgPersBD = false;
  flgDeshabilitaValidar = false;
  flgLectura = false;
  fechaEmisionDni: string;
  nombreMadre = '';
  personaOtro: Persona = null; // new Persona();
  personaRecup: Persona = null; // new Persona();
  flgDNI = false;
  DscMensajeSpinner = DscMensajeSpinner;

  @Output() datosComplementOut = new EventEmitter();
  @Output() setPersonaOtroOut = new EventEmitter();
  @Output() cambioTipoDocOut = new EventEmitter();

  formPersonaNatural = new FormGroup({
    select_tipDocumento : new FormControl('', Validators.required),
    input_nroDoc : new FormControl(''),
    input_apepaterno : new FormControl({value: '', disabled: true}),
    input_apematerno : new FormControl({value: '', disabled: true}),
    input_domicilio : new FormControl(''),
    input_telefono : new FormControl(''),
    input_email : new FormControl(''),
    input_movil : new FormControl('')
  });

  fechaMaxima: string = stringFechaMaxima;
  constructor(protected tipoDocumentoService: TipoDocumentoService,
              protected personaReniecService: PersonaReniecService,
              protected personaService: PersonaService,
              public dialog: MatDialog,
              private spinner: NgxSpinnerService
    ) {

      this.resetPersonaNaturalC();

    }

  ngOnInit() {

    this.tipoDocumentoService.obtenerTipoDocumentoView().subscribe(
      data => {
        this.listTipoDocumento = data;

        this.listTipoDocumento.sort(function(a, b) {

          if (a.ctipdocumentoDsc > b.ctipdocumentoDsc) {
            return 1;
          }

          if (a.ctipdocumentoDsc < b.ctipdocumentoDsc) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });

        // this.formPersonaNatural.controls.select_tipDocumento.setValue("1");


      }
    );

  }

  resetPersonaNaturalC() {

    this.persona = new Persona(); // new Persona();

  }

  setPersonaOtro(data: Persona) {

    this.personaOtro = data;

  }

  setTipDocumentPn(idTipDocumento: number) {

    this.persona.npersonaIdtipdoc = idTipDocumento;

    // console.log("====(idTipDocumento",idTipDocumento);

    this.cambiarTipDocumento(idTipDocumento);

  }

  cambiarTipDocumento(idTipDocumento: number) {

    this.flgDNI = (idTipDocumento == NumIdTipoDocDNI ? true : false);

    this.persona.cpersonaNrodoc = '';
    this.fechaEmisionDni = '';
    this.nombreMadre = '';
    this.persona.cpersonaNombres = '';
    this.persona.cpersonaApepaterno = '';
    this.persona.cpersonaApematerno = '';
    this.persona.tipoDocumento = new TipoDocumento();

    setTimeout(() => {

      for (let i = 0; i < this.listTipoDocumento.length; i++) {

        if (this.listTipoDocumento[i].ntipdocumentoId == idTipDocumento) {

            this.dscMask = this.listTipoDocumento[i].ctipdocumentoMask;
            this.persona.tipoDocumento.ctipdocumentoDsc = this.listTipoDocumento[i].ctipdocumentoDsc;


        }

      }


    }, 0);

    this.cambioTipoDocOut.emit();


    // console.log("00==this.dscMask",this.dscMask);

  }

  _cambioFechaEmision() {

    this.fechaEmisionDni = ValidarFechaLength(this.fechaEmisionDni);

    // var vCantCadena = this.fechaEmisionDni.length;

    // if(vCantCadena > 10)
    // {

    //   this.fechaEmisionDni = this.fechaEmisionDni.substr(vCantCadena - 10);

    // }


  }

  // _cambioNroDoc(e)
  // {

  //   console.log("===event",e);

  //   const charCode = (e.which) ? e.which : e.keyCode;
  //   const input = String.fromCharCode(e.keyCode);

  //   console.log("===input",input);
  //   console.log("===charCode",charCode);

  //   // if(this.onlyNumber){
  //   //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  //   //     return false;
  //   //   }
  //   //   return true;
  //   // }

  //   // if(this.soloNombres)
  //   // {

  //   //   if (/^[A-Za-zñÑáéíóúÁÉÍÓÚ' ]+$/.test(input)) {
  //   //     return true;
  //   //   }


  //   //   return false;

  //   // }

  //   // return true;

  //   // let ctrlActive:boolean = true;

  //   // if (e.key == "Control" || e.code == "KeyC" || e.code == "KeyV") {this.persona.cpersonaNrodoc = null;}

  //   // console.log("====e",e);
  //   // console.log("====e",e.key);
  //   // console.log(ctrlActive);



  //   // return ctrlActive;

  // }

  ValidarReniec() {

    this.personaRecup = new Persona();

    const vFechaEmi = '';
    const vFechaEmiAux = '';
    const vFlgError = false;
    this.flgPersBD = false;

    const dscNombMadre = this.nombreMadre; // this.formPersonaNatural.controls.input_nommadre.value;
    const dscNroDoc = this.persona.cpersonaNrodoc; // this.formPersonaNatural.controls.input_nroDoc.value;
    const vPersonaOtro = this.personaOtro;
    let vPersonaOut: Persona = null;
    let flgConsultaReniec = false;

    // console.log("===========valida renica 1");

    if ( isEmpty(dscNroDoc)) {

      openModalMensaje('Datos Reniec', 'Ingrese el número de documento, por favor verifique', this.dialog);

      return;

    }

    if (isEmpty(dscNombMadre)) {

      openModalMensaje('Datos Reniec', 'Ingrese el apellido materno, por favor verifique', this.dialog);

      return;

    }

    if (vPersonaOtro != null) {

      if (vPersonaOtro.cpersonaNrodoc === dscNroDoc) {

        openModalMensaje('Datos Reniec', 'el número de documento ya fue ingresado, por favor verifique', this.dialog);

        return;

      }

    }
    vPersonaOut = new Persona();

    vPersonaOut.cpersonaNrodoc = dscNroDoc ;

    this.setPersonaOtroOut.emit(vPersonaOut);

    this.flgDeshabilitaValidar = true;

    if (!this.flgPersBD) {

        this.spinner.show();

        this.personaService.obtenerPersonaDni('1', dscNombMadre, dscNroDoc).subscribe(personaMa => {

          this.spinner.hide();

          const resultadoMa: Persona = JSON.parse(JSON.stringify(personaMa));
          let IdPersona = 0;
          if (resultadoMa) {

          this.persona = personaMa;
          flgConsultaReniec = true;
          IdPersona = resultadoMa.npersonaId;
          this.personaRecup = resultadoMa;

            // this._llenarPersona(1, IdPersona);
          } else {

            openModalMensaje('Datos Reniec', 'Apellido Materno no coinciden con los datos de la persona consultada, por favor verifique', this.dialog);
            return;
          }

        }, err => {

          console.log(err);

          this.spinner.hide();

          openModalMensaje('Datos Reniec', 'El documento ingresado es incorrecto', this.dialog);

          this.flgDeshabilitaValidar = false;

        });


    }

  }


  _llenarPersona(numCaso: number, idPersona: number) {

    let vfchBornDate = null;
    let vfchNac = null;
    let codSexo = null;
    let vNumEdad = null;

    switch (numCaso) {
      case 1:
          if (this.personaRecup) {
            this.persona = this.personaRecup;
          }
          this.persona.cpersonaNombres = this.personaReniec.dcFirstName.trim(); // .trim();
          this.persona.cpersonaApepaterno = this.personaReniec.dcLastName1.trim();
          this.persona.cpersonaApematerno = this.personaReniec.dcLastName2.trim();
          this.persona.cpersonaDscdireccion = this.personaReniec.dcAddress.trim();
          this.persona.cpersonaPrinommater = this.personaReniec.dcMotherName.trim(); // .trim();
          this.persona.cpersonaCdepartdomic = this.personaReniec.dcAddDepUbigCode.trim();
          this.persona.cpersonaCprovdomic = this.personaReniec.dcAddProvUbigCode.trim();
          this.persona.cpersonaCdistdomic = this.personaReniec.dcAddDistUbigCode.trim();
          this.persona.strDpersonaFemidoc = ConvertStrDateToFormatBD(this.fechaEmisionDni); // ConvertStringDateStr(this.fechaEmisionDni);
          this.persona.cpersonaCodsexo = this.personaReniec.dcGenter;
          this.persona.npersonaId = idPersona;

          vfchBornDate = ConvertDateTimeToStr3(this.personaReniec.dcBornDate.trim());

          vfchNac = new Date(vfchBornDate);


          codSexo = this.personaReniec.dcGenter;

          this.persona.strDpersonaFnacimiento = ConvertDateTimeToStr4(this.personaReniec.dcBornDate.trim());




          break;

      case 2:

          this.persona = this.personaRecup;



          vfchNac = this.persona.dpersonaFnacimiento;
          codSexo = this.persona.cpersonaCodsexo;

          break;

      default:
        break;
    }


    vNumEdad = ageFromDateOfBirth(vfchNac);



    this.personaOut.numEdad = vNumEdad;
    this.personaOut.strCodSexo = codSexo;

    this.datosComplementOut.emit(this.personaOut);

  }

  personaNaturalCReadEnable() {
    this.flgLectura = true;
  }

  personaNaturalCReadDisable() {
    this.flgLectura = false;
  }

  // setPersonaNaturalC(persona : Persona){

  //   this.persona = persona;
  //   this.nombreMadre = this.persona.cpersonaPrinommater;
  //   this.fechaEmisionDni = ConvertStringDateStr(this.persona.strDpersonaFemidoc,1);

  // }

  setPersonaNaturalC(denunciante: Denunciante, numCaso: number) {

    // console.log("==============denunciante");
    // console.log(denunciante);

    switch (numCaso) {
      case 1:

        this.persona = denunciante.persona;

        this.persona.cpersonaDscdireccion = denunciante.cdenuncianteDscdirecc;
        this.persona.cpersonaDscmovil = denunciante.cdenuncianteDscmovil;
        this.persona.cpersonaDsctelef = denunciante.cdenuncianteDsctelef;
        this.persona.cpersonaDsccorreo = denunciante.cdenuncianteDsccorreo;

        break;

      case 2:

        this.persona = denunciante.personaComplemento;

        this.persona.cpersonaDscdireccion = denunciante.cdenuncianteDscdirecccompl;
        this.persona.cpersonaDscmovil = denunciante.cdenuncianteDscmovilcompl;
        this.persona.cpersonaDsctelef = denunciante.cdenuncianteDsctelefcompl;
        this.persona.cpersonaDsccorreo = denunciante.cdenuncianteDsccorreocompl;

        break;

      default:
        break;
    }

    this.nombreMadre = this.persona.cpersonaPrinommater;
    this.fechaEmisionDni = ConvertStringDateStr(this.persona.strDpersonaFemidoc, 1);

  }


  getPersonaNaturalC() {
    // this.persona = fur.denunciante.persona;
    // this.nombreMadre = this.persona.cpersonaPrinommater;
    // this.fechaEmisionDni = ConvertStringDateStr(this.persona.strDpersonaFemidoc,1);

    // this.persona = persona;

    this.persona.cpersonaPrinommater = this.persona.cpersonaPrinommater;

    return this.persona;
    // this.fechaEmisionDni = ConvertStringDateStr(this.persona.strDpersonaFemidoc,1);

  }



  _mayusculas(e, numCaso: number) {

    let vData = '';

    //e.target.value = e.target.value.toUpperCase();

    // vData = e.target.value.trim();
    vData = e.target.value;

    e.target.value = vData;

    switch (numCaso) {
      case 1:

        this.nombreMadre = vData;

        break;

      case 2:

        this.persona.cpersonaDscdireccion = vData;

        break;

      default:
        break;
    }



   }

  // _mayusculas(e,numCaso:number){
  //  // console.log(e);
  //   e.target.value = e.target.value.toUpperCase();
  //   e.target.value = e.target.value.trim();
  //   //this.nombreMadre = this.nombreMadre.toUpperCase();
  //   // e.key = e.key.toUpperCase();
  // }

  // openDialog(dscTitulo: string, dscMensaje: string) {
  //   const dialogRef = this.dialog.open(ModalMensajeComponent,{ width: '50%',height:'35%',
  //   data: {titulo : dscTitulo,mensaje: dscMensaje}});

  //   dialogRef.afterClosed().subscribe(result => {
  //     //console.log('The dialog was closed');
  //   });
  // }


}
